export const CONFIG_ACTIONS_KEYS = {} as const;

export const CONFIG_GETTERS_KEYS = {
  components: 'components',
  configuredFacets: 'configuredFacets',
  coreComponents: 'coreComponents',
  config: 'config',
  currency: 'currency',
  discoveryWallResultsConfig: 'discoveryWallResultsConfig',
  isDocumentLtr: 'isDocumentLtr',
  facetsGroups: 'facetsGroups',
  facet: 'facet',
  facets: 'facets',
  fallbackFiltersResultConfig: 'fallbackFiltersResultConfig',
  identifierSuggestionsResultConfig: 'identifierSuggestionsResultConfig',
  gridResultConfig: 'gridResultConfig',
  messages: 'messages',
  preFacets: 'preFacets',
  nextQueryResultConfig: 'nextQueryResultConfig',
  redirectionsSuggestionsConfig: 'redirectionsSuggestionsConfig',
  partialsResultConfig: 'partialsResultConfig',
  recommendationsResultConfig: 'recommendationsResultConfig',
  resultsSuggestionsResultConfig: 'resultsSuggestionsResultConfig',
  searchLang: 'searchLang',
  url: 'url'
} as const;

export const CONFIG_MUTATIONS_KEYS = {
  setConfig: 'setConfig',
  setDynamicConfig: 'setDynamicConfig',
  setLocale: 'setLocale',
  setSearchLocale: 'setSearchLocale',
  setCurrency: 'setCurrency',
  setDevice: 'setDevice'
} as const;
